const axios = require("axios");

/* NodeJS */
const url = process.env.REACT_APP_BASE_URL;

module.exports = {
  getLobbyRow: (propertyUid, lobbyRowId, language) =>
    axios({
      method: "GET",
      url: `${url}/lobby_row?language=${language}&property_uid=${propertyUid}&node_id=${lobbyRowId}`,
    }),
};
